import { Stack } from '@mantine/core';
import { useRef } from 'react';
import { useDeepCompareEffect } from 'react-use';
import i18n from '../../../../../base-dictionary';
import { useCostTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setCostSelectedEpics, setCostSelectedTeams } from '../../../../../store/strategy-store/strategy-store.actions';
import { MainSectionControls } from '../../components/main-section-controls/main-section-controls';
import { hasArrayData } from '../../initiative-performance.helpers';
import { useChartData, useCostEpics, useCostTeams } from '../cost-tab.hooks';
import { CostMode } from '../cost-tab.type';
import { TreeMapChart } from './tree-map-chart/tree-map-chart';

export const MainSection = () => {
  const mode = useCostTabStore((state) => state.mode);

  const epics = useCostEpics();
  const teams = useCostTeams();

  useDeepCompareEffect(() => {
    if (epics.length > 0) {
      setCostSelectedEpics(epics);
    }
  }, [epics]);

  useDeepCompareEffect(() => {
    if (teams.length > 0) {
      setCostSelectedTeams(teams);
    }
  }, [teams]);

  const chartRef = useRef<HTMLDivElement>(null!);
  const chartData = useChartData();

  const getTitle = (): string | null => {
    switch (mode) {
      case CostMode.ContributingEpics:
        return i18n.t('strategy.initiative_performance.cost_by_units', {
          units: i18n.t('common.epics'),
        });
      case CostMode.ContributingTeams:
        return i18n.t('strategy.initiative_performance.cost_by_units', {
          units: i18n.t('common.teams'),
        });
      default:
        return null;
    }
  };

  return (
    <Stack h="100%" style={{ overflow: 'hidden', position: 'relative' }}>
      <MainSectionControls title={getTitle()} chartRef={chartRef} disableControls={!hasArrayData(chartData)} />
      <TreeMapChart ref={chartRef} />
    </Stack>
  );
};
